module.exports = __webpack_public_path__ + "img/wxm.ee1c6b9c.png";